import { resolveChartsSource } from "../../../../services/compliance";

type AnalyticsPoint = { label?: string; month?: string; date?: string; value?: number; avgCompliance?: number };
type OverallStats = { yes?: number; partial?: number; no?: number; total?: number };

export function buildTrendChartData(params: {
  analytics: AnalyticsPoint[];
  overallStats?: OverallStats | null;
  isAllStandardsSelected: boolean;
  hasDashboardStandard: boolean;
}) {
  const hasExtended = !!params.overallStats && Number(params.overallStats.total || 0) > 0;
  const source = resolveChartsSource({ hasExtendedData: hasExtended, hasShortData: params.analytics.length > 0 });

  if (!params.isAllStandardsSelected && params.hasDashboardStandard && source === "EXTENDED") {
    const stats = params.overallStats || {};
    const yes = Number(stats.yes || 0);
    const partial = Number(stats.partial || 0);
    const no = Number(stats.no || 0);
    const applicable = yes + partial + no;
    const score = applicable > 0 ? Math.round(((yes * 100) + (partial * 50)) / applicable) : 0;
    return [{ label: "Current", value: score }];
  }

  return params.analytics
    .map((point) => ({
      label: point.label ?? point.month ?? point.date ?? "Unknown",
      value: Number(point.value ?? point.avgCompliance ?? 0),
    }))
    .sort((a, b) => (a.label < b.label ? -1 : 1));
}

